import React from "react";
import CustomCheckbox from "../../Components/CustomCheckBox";
import CardExpiration from "../../Components/Forms/CardExpiration";
import {withButtonLoader} from "../../helpers";

const DebitCardManualEntry = ({
    paymentType,
    handleInputChange,
    isPaymentSaveDetails,
    setIsPaymentSaveDetails,
    isDefault,
    setIsDefault,
    transactionLoading
}) => {
    return (
        <div
            className={`tab-pane fade ${paymentType === "debitCard" ? "show active" : ""}`}
            id="pills-contact"
            role="tabpanel"
            aria-labelledby="pills-contact-tab"
        >
            <div className="sos-content payment-inner-toggleable">
                <form>
                    <div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputEmail1"
                            className="form-label payment-form-label"
                        >
                            Cardholder Name
                        </label>
                        <div className="row g-2">
                            <div className="col-md">
                                <div className="payment-controlpanl-style">
                                    <input
                                        type="text"
                                        name="cardFirstName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder="First Name"
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md">
                                <div>
                                    <input
                                        type="text"
                                        name="cardLastName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder="Last Name"
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputPassword1"
                            className="form-label payment-form-label"
                        >
                            Debit Card Number
                        </label>
                        <input
                            type="text"
                            className="form-control custom-input-border-css"
                            id="debitcardNumber"
                            placeholder="Enter Debit Card Number"
                        />
                    </div>
                    <div className="row g-2">
                        <div className="col-md">
                            <div className="payment-controlpanl-style">
                                <div>
                                    <label className="payment-form-label">
                                        Expiry Date
                                    </label>
                                </div>
                                <CardExpiration
                                    onChange={(e) => handleInputChange(e)}
                                ></CardExpiration>
                            </div>
                        </div>
                        <div className="col-md">
                            <div>
                                <div>
                                    <label className="payment-form-label">
                                        Security Code
                                    </label>
                                </div>
                                <input
                                    type="tel"
                                    className="form-control custom-input-border-css"
                                    id="floatingInputGrid"
                                    placeholder="Enter CVC"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="checkbox-list mt-3">
                        <label
                            className="label-check font-weight-light float-end">
                            <CustomCheckbox
                                name="isPaymentSaveDetails"
                                checked={isPaymentSaveDetails}
                                onChange={(e) => setIsPaymentSaveDetails(!isPaymentSaveDetails)}
                            />
                            Save these payment details for future payments
                        </label>
                        <div className="payment-checbox">
                            <label
                                className="font-weight-light label-check ml-xl-5">
                                <CustomCheckbox
                                    name="isDefault"
                                    checked={isDefault}
                                    onChange={(e) => setIsDefault(!isDefault)}
                                />
                                Set as default payment method
                            </label>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button
                            type="submit"
                            className="sos-mack-btn sos-custom-btn-css"
                            disabled={transactionLoading}
                        >
                            {withButtonLoader("Make a Payment", transactionLoading)}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DebitCardManualEntry;
